import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import Button from '../customButtons/Button'; 

// --- Navbar Component ---
const Navbar = ({ isSidebarOpen, onToggleSidebar }) => {
  const { user } = useAuth();
  
  const displayFirstName = user?.firstName || 'User';
  const displayBusinessName = user?.business || 'Your Agribusiness';

  return (
    <nav className="fixed top-0 left-0 right-0 z-40 bg-white shadow-sm h-16 flex items-center justify-between px-4 sm:px-6 border-b border-gray-200">
      <div className="flex items-center space-x-4">
        {/* Sidebar toggle */}
        <button
          onClick={onToggleSidebar}
          className="p-2 rounded-lg text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-custom-teal border" 
          aria-label={isSidebarOpen ? "Close sidebar" : "Open sidebar"}
        >
          {isSidebarOpen ? (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>

        {/* Branding */}
        <div className="flex items-center">
          <span className="text-xl md:text-[18px] font-bold text-custom-teal">
            {displayBusinessName}
          </span>
        </div>
      </div>

      {/* Right section */}
      <div className="flex items-center space-x-3">
        {/* User Profile */}
        <div className="flex items-center space-x-2">
          <span className="hidden md:inline-block text-sm font-medium text-gray-700">{displayFirstName}</span>
          <button className="p-2 rounded-md text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-custom-teal" aria-label="User profile">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5.121 17.804A11.952 11.952 0 0112 15c4.786 0 8.763 2.946 9.879 5.804M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;